export default {
  main:{ // 一级菜单
    // 人员管理
    people_mng:{
      custom: true,
      icon : "personnel",
    },
    // 设备
    equip_mng:{
      custom: true,
      icon : "device",
    },
    // 审批管理
    atd_mng:{
      custom: true,
      icon : "approvel",
    },
    // 机构设置
    organiz:{
      custom: true,
      icon : "organization",
    },
    // 门禁管理
    access_control:{
      custom: true,
      icon : "access_control",
    },
  },
  sub:{ // 二级菜单
    person_list:"/peoplemng/personlist",
    // 设备管理
    equip_area:"/equipmng/equiparea",
    device_list:"/equipmng/devicelist",
    // 审批
    my_appr: "/attdmng/myqppr",
    instit_info: "/oragni/instituInfo",
  },
}